import { GET, POST } from './index';
import { apiCache } from '../utils/apiCache';

// เริ่มพัก
export const startBreak = async (breakData) => {
  try {
    const response = await POST('/api/v1/websocket/break/start', breakData);
    return response;
  } catch (error) {
    throw error;
  }
};

// จบพัก
export const endBreak = async (userId, type) => {
  try {
    const response = await POST('/api/v1/websocket/break/end', { userId, type });
    return response;
  } catch (error) {
    throw error;
  }
};

// ดูสถานะพักปัจจุบัน (with cache)
export const getBreakStatus = async () => {
  const key = apiCache.generateKey('/api/v1/websocket/break/status');
  return apiCache.execute(key, async () => {
    try {
      const response = await GET('/api/v1/websocket/break/status');
      return response;
    } catch (error) {
      throw error;
    }
  }, 8000); // 8 seconds cache (ลดลงจาก 15 วินาที)
};

// เข้างาน
export const checkIn = async (userId) => {
  try {
    const response = await POST('/api/v1/websocket/work/checkin', { userId });
    return response;
  } catch (error) {
    throw error;
  }
};

// ออกงาน
// reason: 'offline'   = กดปุ่มออฟไลน์ (พักชั่วคราว) → backend กระจายเคสที่ถืออยู่ต่อให้คนอื่นที่ทำ task เดียวกัน
//         'clock_out' = ตอกบัตรออกงาน (จบกะ) → เคสลงกล่องกลาง (assign_to = null) เหมือนเดิม
// default 'clock_out' ให้ตรงกับ default ฝั่ง backend
export const checkOut = async (userId, reason = 'clock_out') => {
  try {
    const response = await POST('/api/v1/websocket/work/checkout', { userId, reason });
    return response;
  } catch (error) {
    throw error;
  }
};

// ===== ตอกบัตร (Time clock) — user/company มาจาก header อัตโนมัติ =====
// ตอกบัตร เข้า/ออกงาน: type = 'in' | 'out'
export const punchClock = async (type) => {
  try {
    const response = await POST('/api/v1/timeclock/punch', { type });
    return response;
  } catch (error) {
    throw error;
  }
};

// สถานะตอกบัตรวันนี้: result.state = 'none' | 'in' | 'done'
export const getTimeClockStatus = async () => {
  try {
    const response = await GET('/api/v1/timeclock/status');
    return response;
  } catch (error) {
    throw error;
  }
};

// ดูสถานะของผู้ใช้ (with cache)
export const getUserStatus = async (userId) => {
  const key = apiCache.generateKey(`/api/v1/websocket/work/status/${userId}`);
  return apiCache.execute(key, async () => {
    try {
      const response = await GET(`/api/v1/websocket/work/status/${userId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }, 10000); // 10 seconds cache (ลดลงจาก 30 วินาที)
};

// ดูสถานะพนักงานในกะปัจจุบัน (with cache)
export const getCurrentShiftEmployees = async (userId = null, userRole = null) => {
  const params = { userId, userRole };
  const key = apiCache.generateKey('/api/v1/websocket/work/current-shift-employees', params);
  return apiCache.execute(key, async () => {
    try {
      const queryParams = new URLSearchParams();
      if (userId) queryParams.append('userId', userId);
      if (userRole) queryParams.append('userRole', userRole);
      
      const url = `/api/v1/websocket/work/current-shift-employees?${queryParams.toString()}`;
      const response = await GET(url);
      return response;
    } catch (error) {
      throw error;
    }
  }, 20000); // 20 seconds cache (ลดลงจาก 45 วินาที)
}; 